module.exports = __webpack_public_path__ + "static/media/dolanSetup1.5ad71aa5.jpg";